const Pagination = ({
  count,
  page,
  onChange
}) => {


  return <div className="flex ">
    <button className="rounded-full p-1 bg-blue-500 disabled:bg-blue-400 hover:bg-blue-600 active:bg-blue-700 px-2 text-white font-semibold mx-1"
      disabled={page == 1}
      onClick={() => {
        onChange(page - 1)
      }}
    >Prev</button>
    Page {page} of {count}
    <button className="rounded-full p-1 bg-blue-500 disabled:bg-blue-400 hover:bg-blue-600 active:bg-blue-700 px-2 text-white font-semibold mx-1"
      disabled={page == count}
      onClick={() => {
        onChange(page + 1)
      }}
    >Next</button>


  </div>


}

export default Pagination
